var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { memo } from 'react';
import { debounce } from 'lodash';
import "./Slider.scss";
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.timer = setTimeout(_this.findInput, 200);
        };
        _this.onSliderChange = function (_a) {
            var detail = _a.detail;
            if (_this.props.onSliderValueChange) {
                _this.props.onSliderValueChange(detail.value);
            }
        };
        _this.sliderInput = null;
        _this.onSliderChange = _this.onSliderChange.bind(_this);
        _this.findInput = _this.findInput.bind(_this);
        // this.detectChange = this.detectChange.bind(this);
        _this.currentValue = "".concat(_this.props.initialValue);
        return _this;
    }
    Slider.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    Slider.prototype.findInput = function () {
        var sliderElement = document.getElementById(this.props.id);
        if (sliderElement) {
            sliderElement.addEventListener("sliderChange", debounce(this.onSliderChange, 200));
        }
        else {
            clearTimeout(this.timer);
            this.timer = setTimeout(this.findInput, 200);
        }
    };
    Slider.prototype.render = function () {
        var _a = this.props, id = _a.id, step = _a.step, minValue = _a.minValue, maxValue = _a.maxValue, initialValue = _a.initialValue;
        return React.createElement("sdds-slider", { id: id, step: step, min: minValue, max: maxValue, value: initialValue, input: true, tooltip: true });
    };
    return Slider;
}(React.Component));
export default memo(Slider);
